// Module
var code = "<!-- ko if: IsAuthenticated --> <div class=\"text-sm sps-btn sps-btn-outline text-sm sps-btn rounded-full p-0 size-[40px] relative sidebar-toggler\"> <i class=\"fa-solid fa-angle-left sidebar-toggler--icon\"></i> </div> <!-- /ko -->";
// Exports
export default code;